/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';

import { appActions } from "@/store/actions/app.actions";
import { authActions } from '@/store/actions/auth.actions';
import api from '@/services/api';

import { getUrls } from '@/utils/urls/getUrls';

import ModalWrapper from '@/views/components/Modal/ModalWrapper';
import { cookieService } from "@/services/cookie";

const PageWrapper = ({urlAccessMode = 0,  children }) => {
	const appError = useSelector(state => state.app.appError);
	const user = useSelector(state => state.auth.user);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { simpleText } = getUrls();

	// login
	const { isLoggedIn, csrf } = useSelector(state => state.auth);
	// const storageCsrf = sessionStorage.getItem('csrf');
	const storageCsrf = cookieService.getToken();
	const { pathname, search } = useLocation();

	const [ logged, setLogged ] = useState(false);

	useEffect(() => {
		if (user && user.role) {
			const userRole = user.role;
			if ((userRole === 'reader' && urlAccessMode > 0) || (userRole === 'editor' && urlAccessMode > 1)){
				return navigate(simpleText, { replace: true });
			}
		}
	}, [ user, urlAccessMode ]);

	useEffect(() => {
		dispatch(authActions.setLoginReturnUrl({path: `${pathname}${search}`, urlAccessMode}));
	}, [ pathname, search, dispatch ]);

	useEffect(() => {
		if (!isLoggedIn || !csrf) {
			// no data in store, check storage
			if (storageCsrf && storageCsrf.length) {
				dispatch(authActions.signIn({ token: storageCsrf }));
				return;
			} else {
				dispatch(authActions.setLoginReturnUrl({
					path: `${pathname}${search}`, urlAccessMode,
				}));
				navigate('/login', { replace: true });
			}
		} else if (isLoggedIn && csrf) {
			api.get('/auth/me').then((response) => {
				setLogged(true);
				dispatch(authActions.setUser(response.data));
			});
		}
		// eslint-disable-next-line
    }, [isLoggedIn, csrf]);

	useEffect(() => {
		const dispatchActions = () => {
			dispatch(appActions.setError(0));
			dispatch(authActions.setLoginReturnUrl({
				path: `${pathname}${search}`,
				urlAccessMode,
			}));
		};

		if (appError === 404) {
			dispatchActions();
			navigate('/page404');
		}
		if (appError === 500) {
			dispatchActions();
			navigate('/page500');
		}
		if (appError === 403) {
			dispatchActions();
			navigate('/login');
		}
		// eslint-disable-next-line
    }, [appError]);

	return (
		<>
			{ logged && (
				<ModalWrapper>
					{children}
				</ModalWrapper>
			)}
		</>
	);
};

export default PageWrapper;
